package com.essntl.core.waypoint.data.response

import kotlinx.serialization.Serializable

@Serializable
data class WaypointData(
    val id: String,
)
